import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// Design system: tokens+base first, then theme overrides, utilities,
// components; motion last so its reduced-motion kill switch wins the cascade.
import './index.css';
import './styles/themes.css';
import './styles/utilities.css';
import './styles/components.css';
import './styles/motion.css';
import App from './App';
import { AuthProvider } from './AuthContext';
import { ToastProvider } from './components/Toast';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
